import React from "react";
import "./itemList.scss"

export const ItemList = ({ items, title, className }) => (
    <div className={`list-container ${className}`}>
        {title && <h5>{title}</h5>}
        <ul>
            {items.map((item, index) => (
                <li key={index}>{item}</li>
            ))}
        </ul>
    </div>
);